<template lang="pug">
  .lesson-block-add(@click="addBlock")
    .lesson-block-add__content
      .lesson-block-add__dashes
      Icon.lesson-block-add__icon(icon="plus-circle")

</template>

<script>
export default {
  props: ['partId', 'block'],
  methods: {
    addBlock() {
      this.$store.dispatch('coursesLesson/setAsideData', {
        path: 'parent',
        value: { partId: this.partId, block: this.block }
      });
      this.$store.dispatch('coursesLesson/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-block-add {
  top: calc(100% - 12px);
}

.lesson-block-add__content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
}

.lesson-block-add__icon {
  height: 32px;
}
</style>